<template>
  <v-app id="inspire" style="background: #2562af;" class="Kanit">
    <v-card flat class="hidden-sm-and-down">
      <v-container fluid>
        <v-layout row>
          <div style="width: 100vw;">
            <v-toolbar dark app class="tabssright">
              <v-toolbar-title class="ml-0 pl-0"></v-toolbar-title>
              <img src="./../assets/image/logoonechat_full-white.png" style="height: 60px; border-radius: 10px;margin-left: 4vw;cursor: pointer;" @click="toPage('/#home')">
              <v-spacer></v-spacer>
              <v-avatar size="50px" v-if="filename != ''" @click="gotoLink('/develop/information_dev')"><img :src="filename" class="alligator-turtle" style="cursor: pointer;"></v-avatar>
              <v-avatar size="50px" v-else @click="gotoLink('/develop/information_dev')"><img src='./../assets/robot/developer1.png' class="alligator-turtle" style="cursor: pointer;"></v-avatar>
              <div>
                <v-menu bottom offset-y>
                  <v-btn flat slot="activator" row wrap>
                    <p class="textlayout Kanit" style="padding-left: 0vw;">{{myname}}</p>
                    <v-icon style="font-size: 25px !important;">expand_more</v-icon>
                  </v-btn>
                  <v-list>
                    <v-list-tile @click="gotoLink('/develop/information_dev')">
                      <v-icon meduim>person</v-icon>&nbsp;&nbsp;<v-list-tile-title class="Kanit">ข้อมูล API</v-list-tile-title>
                    </v-list-tile>
                    <v-list-tile @click="gotoLink('/develop/createbot')">
                      <v-icon meduim>create</v-icon>&nbsp;&nbsp;<v-list-tile-title class="Kanit">สร้างบอท</v-list-tile-title>
                    </v-list-tile>
                    <v-list-tile v-for="(item, index) in listmenu" :key="index" @click="showDialog(item.dialog)">
                      <v-icon meduim>{{item.icon}}</v-icon>&nbsp;&nbsp;<v-list-tile-title class="Kanit">{{ item.title }}</v-list-tile-title>
                    </v-list-tile>
                    <v-list-tile @click="logout()">
                      <v-icon meduim>lock_open</v-icon>&nbsp;&nbsp;<v-list-tile-title class="Kanit">ออกจากระบบ</v-list-tile-title>
                    </v-list-tile>
                  </v-list>
                </v-menu>
              </div>
            </v-toolbar>
          </div>
        </v-layout>
      </v-container>
    </v-card>
    <v-layout row wrap v-if="status_login === 'T'" class="hidden-sm-and-down" style="height: 100%;">
      <v-flex md3 lg3 xl3 class="hidden-sm-and-down" style="background-color: white !important;">
        <LeftTool />
      </v-flex>
      <v-flex md9 lg9 xl9 style="background-color: white !important; height: 100%;">
        <router-view></router-view>
      </v-flex>
    </v-layout>
    <FeedbackDialog :feedbackdialog="feedbackdialog" v-on:closeHelp="closeFriend"></FeedbackDialog>
    <HelpDialog :helpcenterDialog="helpdialog" v-on:closeHelpcenter="closeFriend"></HelpDialog>
    <PolicyDialog :policydialog="policydialog" v-on:closePolicy="closePolicy"></PolicyDialog>
  </v-app>
</template>
<script>
  import { mapState } from 'vuex'
import LeftTool from '@/components/managebot/leftpage'
import FeedbackDialog from '@/components/managebot/dialogNavbar/feedbackDialog'
import HelpDialog from '@/components/managebot/dialogNavbar/helpcenterDialog'
import PolicyDialog from '@/components/managebot/dialogNavbar/policyDialog'

export default {
  data: () => ({
    // room: '',
    policydialog: false,
    feedbackdialog: false,
    helpdialog: false,
    dialog: false,
    drawer: null,
    filename: '',
    myname: '',
    // token: '',
    webbackend: '',
    status_login: '',
    listmenu: [
      {
        title: 'ข้อเสนอแนะ',
        icon: 'feedback',
        dialog: 'feedbackdialog'
      },
      {
        title: 'ศูนย์ช่วยเหลือ',
        icon: 'contact_support',
        dialog: 'helpdialog'
      },
      {
        title: 'นโยบายความเป็นส่วนตัว',
        icon: 'book',
        dialog: 'policydialog'
      }
    ],
  }),
  props: {
    source: String
  },
  methods: {
    gotoLink (link) {
      if (link === 'logout') {
        this.logout()
      } else {
        this.$router.push(link)
      }
    },
    toPage (page) {
      this.$router.push(page)
    },
    showDialog (dialog) {
      if (dialog === 'helpdialog') {
        this.helpdialog = true
      } else if (dialog === 'feedbackdialog') {
        this.feedbackdialog = true
      } else if (dialog === 'policydialog') {
        this.policydialog = true
      }
    },
    closePolicy (value) {
      this.policydialog = value
    },
    closeFriend (value) {
      this.helpdialog = value
      this.feedbackdialog = value
    },
    logout () {
      localStorage.clear()
      if (process.env.LogoutOneid) {
        window.open(process.env.LogoutOneid, '_parent')
      } else {
        this.$router.push('/login')
      }
    },
    policy () {
      window.open('/policy', '_blank')
    }
  },
  components: {
    LeftTool,
    // EditProfileDialog,
    // KeepFileDialog,
    FeedbackDialog,
    HelpDialog,
    PolicyDialog
  },
  computed: {
    ...mapState({
      myprofile: 'myprofile',
      sendrequest: 'sendrequest',
      request: 'request',
      groupreq: 'groupreq'
    })
  },
  watch: {
    myprofile () {
      this.filename = localStorage.getItem('profilepicture')
      this.myname = localStorage.getItem('name')
    }
  },
  created () {
    // this.room = this.$router.currentRoute.path
    this.webbackend = process.env.API
    // this.token = localStorage.getItem('tokenuser')
    this.filename = localStorage.getItem('profilepicture')
    this.myname = localStorage.getItem('name')
    this.status_login = localStorage.getItem('status_login')
  }
}
</script>
<style type="text/css" scoped>

.Kanit {
  font-family: 'Kanit', sans-serif !important;
  word-wrap: break-word;
}

b {
  font-weight: 900 !important;

}

.tabss {
  background-color: #2562af !important;
}

.tabssright {
  background-color: #2562af !important;
}

.tabs__bar .icon--right {
  right: 10px !important;
}

.tabs__bar .icon--left {
  left: 10px !important;
}

.tabs:not(.tabs--grow):not(.tabs--mobile) .tabs__item {
  padding: 0 15px !important;
}

.alligator-turtle {

  object-fit: cover;
  object-position: 50% 0;
}

.text {
  white-space: nowrap;
  width: 100px;
  overflow: hidden;
  text-overflow: ellipsis;
  padding-right: 10px;
  padding-top: 0px;
  font-family: 'CS ChatThaiUI' !important;
}

.textlayout {
  white-space: nowrap;
  width: 9em;
  overflow: hidden;
  text-overflow: ellipsis;
  padding-right: 0vw;
  padding-top: 1vh;
  padding-left: 2vw;
  /*font-family: 'CS ChatThaiUI' !important;*/
  font-size: 18px;
  padding-bottom: 0px;
  color: white;
  text-transform: none;
}

span.badge__bage.red {
  left: 27px;
}

.icon {
  font-size: 25px !important;
}

.badge--overlap .badge__badge {
  top: -12px;
  right: -9px;
}

.application .theme--light.list .list__tile:not(.list__tile--active),
.theme--light .list .list__tile:not(.list__tile--active) {
  padding: 2vw !important;
}

/*.application .theme--light.list, .theme--light .list {
  padding: 2vw !important;
}*/
.CSChatThai {
  font-family: 'CS ChatThaiUI' !important;
  word-wrap: break-word;
}

.listmenuweb {
  padding-left: 8px !important;
}

.list {
  padding-left: 8px !important;
}

</style>



// WEBPACK FOOTER //
// src/components/managebot/Layout.vue